<template>
  <!-- ConfigManage -->
  <div class="content list report-list contract-manage">
    <div class="row">
      <div class="col-sm-12">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>Administrator</el-breadcrumb-item>
          <el-breadcrumb-item>Contract Manage</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">选择功能</h4>
          <el-check-tag
            v-for="(item, index) in labels"
            :key="item"
            :checked="item.checked"
            @change="changeLabel(index)"
            >{{ item.label }}</el-check-tag
          >
        </el-card>
      </div>
    </div>
  </div>
  <el-card v-if="tabs.length > 0">
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in tabs"
        :key="item"
        :label="item.name"
        :name="item.name"
      >
        <component :is="item.component"></component>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script setup>
import { ref } from 'vue';
import cancelRevise from './cancelRevise';
const labels = ref([
  { label: 'Cancel Revise', checked: false, component: cancelRevise },
]);
const tabs = ref([]);
const activeName = ref();

const changeLabel = (index) => {
  var item = labels.value[index];

  var { checked, label } = item;
  item.checked = !checked;

  if (item.checked) {
    tabs.value.push({
      index: tabs.value.length,
      name: label,
      component: item.component,
    });
    activeName.value = label;
  } else {
    tabs.value.splice(tabs.value.find((t) => t.name === label).index, 1);
  }
};
</script>
<style scoped>
.contract-manage .row {
  margin-bottom: 8px;
}
</style>
